exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".breadcrumbs{list-style:none;padding:0;margin:0 0 15px;color:grey;text-align:center}.breadcrumbs li{display:inline}.breadcrumbs li::after{content:' > '}.breadcrumbs li:last-child::after{content:''}.breadcrumbs li a,.breadcrumbs li a:focus,.breadcrumbs li a:active{color:grey}\n", ""]);

